export function incidentErrorMessage(error: any, fallback: string) {
  const raw = error?.response?.data?.message ?? error?.message;
  if (Array.isArray(raw)) {
    return raw.filter((item) => typeof item === "string").join(". ");
  }
  if (typeof raw === "string" && raw.includes("incidents.release")) {
    return "No puedes liberar incidencias de alguien que no está en tu equipo.";
  }
  if (typeof raw === "string" && raw.trim()) {
    return raw;
  }
  return fallback;
}
